import { render, staticRenderFns } from "./PrefixEdit.vue?vue&type=template&id=8f73398e&"
import script from "./PrefixEdit.vue?vue&type=script&lang=js&"
export * from "./PrefixEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports